<template>
	<sf-data-table
		ref="partMngTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		selection
		:columns="columns"
		:rows="rows"
		fit="fit"
		select
		:stripe="false"
		:excel="isButton_(scrId, 'EX')"
		@changedPage="changedPage"
	>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'ckuTm'">
				<el-input :value="slotProps.row.ckuTm" @input="val => changeInput(val, slotProps.row)" maxLength="5"></el-input>
			</template>
			<!-- 협력사  -->
			<template v-if="slotProps.column.property === 'newCofNm'">
				<div class="position-relative h-100">
					<el-input class="pr-2" :value="slotProps.row.newCofNm" :placeholder="getMessage_('QWCC001656')" readonly></el-input>
					<span class="unit input-icon">
						<i class="icon-sf-search search-icon" @click="() => onCofPopup(slotProps)"></i>
					</span>
				</div>
			</template>
		</template>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('QWCC001131') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam: { type: Object }
	},
	async created() {
		await this.getCommCodes_({ key: 'ckuScnList', codeType: 'CKU_SCN' }); //검사구분;
		await this.getCommCodes_({ key: 'ckuPartScnList', codeType: 'CKU_PART_SCN_CD' }); //검사부품구분;
		await this.getCommCodes_({ key: 'sttsPartList', codeType: 'STTS_PART_CD' }); //현황부품구분;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return this.getColumns_;
		},
		schema() {
			return Yup.object().shape({
				ckuScnCd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000987')])),
				cofCd: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000958')])),
				oldCofNm: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000958')])),
				newCofNm: Yup.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000958')])),
				ckuTm: Yup.number()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC000068'), [this.getMessage_('QWCC001916')])) //{0}은(는) 숫자만 입력 가능합니다. , 검사시간
					.positive(this.$sf_formatString(this.getMessage_('SWCC000964'), [this.getMessage_('QWCC001916')])) //{0}은(는) 양수만 입력 가능합니다. , 검사시간
					.max(99999, this.$sf_formatString(this.getMessage_('QWCC001118'), [this.getMessage_('QWCC001916'), '5'])) //{0}은 최대 {5} 자리까지 입력 가능합니다.
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001916')])) //{0}은(는) 팔수 입력 값 입니다. , 검사시간
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeInput(value, row) {
			value = value.replace(/[^0-9]/g, '');
			row.ckuTm = value;
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		resetTable() {
			this.$emit('Refresh');
		},
		saveAction() {
			const selected = this.$refs.partMngTable.getSelectedRows();
			if (!selected.length) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_('SWCC000501'),
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		async save() {
			try {
				const selected = this.$refs.partMngTable.getSelectedRows();
				// 유효성 검사
				for (let i = 0; i < selected.length; i++) {
					this.schema.validateSync(selected[i]);
				}

				let flag = '';

				//협력사 셋팅된 값을 체크
				selected.forEach(element => {
					if (element.oldCofNm != element.newCofNm) {
						flag = 'E';
					}
				});
				//협력사 셋팅된 값이 틀리면 저장하면 안됨.
				if (flag == 'E') {
					throw new Error(this.getMessage_('QWCC001926'));
				}

				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.updatePart_(selected);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		//OP코드(공통코드)그리드 팝업 오픈 호출
		onCofPopup(param) {
			const sendData = {
				cpnyScn: '10',
				cpnyCd: param.row.newCofNm
			};
			this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.
			this.$emit('OpenCofPopup', sendData);
		}
	},
	watch: {
		sendParam(newValue, oldValue) {
			this.commCd = this.sendParam;
			let dataArr = this.resultList.slice();
			dataArr[this.selGridRowIndex].cofCd = newValue.cpnyCd;
			dataArr[this.selGridRowIndex].oldCofNm = newValue.cpnyNm;
			dataArr[this.selGridRowIndex].newCofNm = newValue.cpnyNm;
		}
	}
};
</script>

<style></style>
